import Box from "@mui/material/Box";
import { Link } from "@/lib/next-mui/Link";
import { useRouter } from "next/router";

/**
 * Imprint and core legal page links for pages without the side menu
 * (landing / website layout).
 */
export function LegalFooter() {
  const router = useRouter();
  const loginHref = `/login?callbackUrl=${encodeURIComponent(router.asPath)}`;

  return (
    <Box
      component="footer"
      sx={(theme) => ({
        py: 2,
        px: 2,
        textAlign: "center",
        borderTop: 1,
        borderColor: "divider",
        color: "text.secondary",
        fontSize: theme.typography.body2.fontSize,
        flexShrink: 0,
      })}
    >
      <Box component="nav" aria-label="Legal and company information">
        <Link href="/imprint" color="inherit" underline="hover">
          Imprint
        </Link>
        {" · "}
        <Link href="/terms" color="inherit" underline="hover">
          Terms of Service
        </Link>
        {" · "}
        <Link href="/privacy" color="inherit" underline="hover">
          Privacy Policy
        </Link>
        {" · "}
        <Link href="/pricing" color="inherit" underline="hover">
          Pricing
        </Link>
        {" · "}
        <Link href={loginHref} color="inherit" underline="hover">
          Sign in
        </Link>
      </Box>
    </Box>
  );
}
